import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { RouteCMRController } from '@shared/src/controllers/route/cmr/routecmr.controller';
import { Route_eCMRTransportDateDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRTransportDateDto';

@Component({
  selector: 'updatetransportdatedialog-dialog',
  templateUrl: './updatetransportdatedialog.dialog.component.html'
})
export class UpdateTransportDateDialogDialogComponent {

  @Output() public onResolve: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private mdDialogRef: MatDialogRef<UpdateTransportDateDialogDialogComponent>,
    private mdDialog: MatDialog,
    private ecmrController: RouteCMRController,
    private openEcmrController: OpenRouteCMRController) { }

  onClose() {
    this.onResolve.next(false);
    this.mdDialog.closeAll();
  }

  onConfirm() {
    if (!this.data.external) {
      this.ecmrController[this.data.momentType](this.data.routePartCMRId, Route_eCMRTransportDateDto.build(this.data.moment)).subscribe(e => {
        if (e) {
          this.onResolve.next(true);
          this.mdDialog.closeAll();
        }
      });
    } else {
      this.openEcmrController[this.data.momentType](this.data.routePartCMRId, Route_eCMRTransportDateDto.build(this.data.moment)).subscribe(e => {
        if (e) {
          this.onResolve.next(true);
          this.mdDialog.closeAll();
        }
      });
    }
  }
}
